function calcHeaderHeightCSS() {
  // calculate css header height variable
  const root = document.documentElement;

  const element = document.querySelector<HTMLElement>(".header__inner");

  if (!element) {
    return;
  }

  root.style.setProperty(
    "--header-height",
    document.defaultView?.getComputedStyle(element).height || 0 + "px"
  );
}

let calcTimer: ReturnType<typeof setTimeout> | null = null;
function calcHeaderHeightCSSEvent() {
  // Calculate height instantly
  calcHeaderHeightCSS();

  // Calculate height on a delayed timer
  if (calcTimer) {
    clearTimeout(calcTimer);
    calcTimer = null;
  }
  calcTimer = setTimeout(calcHeaderHeightCSS, 150);
}

calcHeaderHeightCSSEvent();
window.addEventListener("load", calcHeaderHeightCSSEvent);
window.addEventListener("resize", calcHeaderHeightCSSEvent, true);

const toggleTarget = document.querySelector<HTMLElement>(
  ".header__toggle-target"
);
toggleTarget?.addEventListener("click", function () {
  const body = document.querySelector<HTMLElement>("body");
  body?.classList.toggle("menu-active");
});
